/**
 * A one-time tip for phone and tablet players: the game works on phones, but the big screens (financials,
 * charts, the World) are best on a computer. Shown once, small, after the first month closes (never over the
 * login or first screen), gone after a few seconds or one tap, and remembered in this browser. Computers never see it.
 */
const GES_TIP_KEY = "ges.deviceTipSeen";

function gesIsSmallDevice() {
  const narrow = typeof window.matchMedia === "function" && window.matchMedia("(max-width: 900px)").matches;
  const mobileUa = /Mobi|Android|iPhone|iPad|iPod/i.test((navigator && navigator.userAgent) || "");
  return narrow || mobileUa;
}

function gesTipSeen() {
  try { return localStorage.getItem(GES_TIP_KEY) === "1"; } catch (e) { return false; }
}

function gesShowDeviceTip() {
  if (gesTipSeen() || !gesIsSmallDevice() || document.getElementById("ges-device-tip")) return;
  const tip = document.createElement("div");
  tip.id = "ges-device-tip";
  tip.className = "device-tip";
  tip.setAttribute("role", "status");
  // 2.7 (D6): one small line, once, after the first month (it used to cover the first screen); it fades by itself
  tip.innerHTML = `<span class="device-tip-text">💻 Charts and the World are easier on a big screen. Your game saves, so switch any time.</span>
    <button type="button" class="device-tip-ok" aria-label="Close">✕</button>`;
  try { localStorage.setItem(GES_TIP_KEY, "1"); } catch (e) { /* private mode: shown again next visit */ }
  const close = () => tip.remove();
  tip.querySelector(".device-tip-ok").addEventListener("click", close);
  setTimeout(close, 9000);
  document.body.appendChild(tip);
}

/** Wait for the game screen (not the login or founding screens), then show the tip once. */
function gesWatchForGameScreen() {
  const dash = document.getElementById("dashboard-screen");
  if (!dash || gesTipSeen() || !gesIsSmallDevice()) return;
  // later (2.7): only once the first month has closed, never over the first screen
  const monthDone = () => { const m = document.getElementById("kpi-month"); return !!m && (parseInt(m.textContent, 10) || 0) >= 1; };
  const ready = () => !dash.classList.contains("hidden") && !document.getElementById("auth-screen") && monthDone();
  const check = () => { if (ready()) { stop(); setTimeout(gesShowDeviceTip, 1500); } };
  const obs = typeof MutationObserver === "function" ? new MutationObserver(check) : null;
  const stop = () => obs && obs.disconnect();
  if (obs) obs.observe(document.body, { attributes: true, childList: true, subtree: true, characterData: true, attributeFilter: ["class"] });
  check();
}

if (typeof window !== "undefined" && typeof document !== "undefined") {
  window.gesShowDeviceTip = gesShowDeviceTip;
  try { gesWatchForGameScreen(); } catch (e) { /* a tip must never break the game */ }
}
